module.exports = __webpack_public_path__ + "media/images/event/event2-798010e7e2faf74e74775ea85e3b9d90.png";